import axiosInstance from './axiosInstance';

/**
 * 배역별 AI 추천 배우 (제작사 · 공고 주인 전용)
 *
 * 서버가 공고를 만들거나 고치거나 열 때 미리 계산해 DB에 두고, 화면은 저장된 결과를 읽는다.
 * 개발 서버(npm start)에서 REACT_APP_AI_RECOMMEND_MOCK=true 이면 서버 대신 가짜 응답을 준다 (디자인 확인용).
 *
 * 조건은 아래처럼 NODE_ENV를 먼저 본다. 이 변수가 .env에 없으면 CRA가
 * process.env.REACT_APP_AI_RECOMMEND_MOCK을 상수로 바꾸지 못해 분기가 남고, 가짜 데이터
 * 청크와 함께 REACT_APP_* 값 전체가 번들에 박힌다. NODE_ENV는 늘 상수로 바뀌므로 운영
 * 빌드에서는 'production' !== 'production' → false로 접혀 분기와 동적 import가 통째로 빠진다.
 * 같은 이유로 동적 import 앞의 조건은 상수에 담지 않고 그 자리에 그대로 쓴다.
 */
export const AI_RECOMMEND_MOCK = process.env.NODE_ENV !== 'production' && process.env.REACT_APP_AI_RECOMMEND_MOCK === 'true';

/**
 * @param {number|string} postId
 * @returns {Promise<{ roles: Array<{
 *   roleId: number, roleName: string,
 *   status: 'PENDING'|'RUNNING'|'DONE'|'FAILED'|'NO_MATCH'|null,
 *   updatedAt: string|null, error?: string|null,
 *   criteria: Array<{ id: string, label: string, definition?: string, type?: 'appearance'|'fact', weight: number }>,
 *   items: Array<object>
 * }> }>}
 */
export const getCastingRecommendations = async (postId) => {
  if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_AI_RECOMMEND_MOCK === 'true') {
    const { mockGetRecommendations } = await import('./recommendationMock');
    return mockGetRecommendations(postId);
  }
  const res = await axiosInstance.get(`/api/castings/${postId}/recommendations`);
  const data = res.data;
  // 배열을 그대로 주든 { roles: [...] }로 감싸 주든 받는다 (계약서에 감싸는 키가 정해져 있지 않다)
  const roles = Array.isArray(data) ? data : (data?.roles ?? data?.content ?? []);
  return { roles };
};

/**
 * 한 배역의 추천을 다시 계산해 달라고 요청한다. 서버는 202를 주고 비동기로 돈다.
 * 같은 배역은 1분에 한 번만 받는다 (넘으면 429).
 */
export const refreshRoleRecommendations = async (postId, roleId) => {
  if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_AI_RECOMMEND_MOCK === 'true') {
    const { mockRefreshRecommendations } = await import('./recommendationMock');
    return mockRefreshRecommendations(postId, roleId);
  }
  const res = await axiosInstance.post(`/api/castings/${postId}/roles/${roleId}/recommendations/refresh`);
  return res.data;
};
